import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Flex,
  Image,
  HStack,
  useToast,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Spinner,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Link,
  Switch,
} from "@chakra-ui/react";
import { FaRegCopy, FaSortDown, FaSortUp } from "react-icons/fa6";
import NFTView from "./NFTView";
import axios from "axios";
import Chart from "./Chart";
import Transactions from "./Transactions";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import PieCharts from "./PieCharts";
import { useWallet } from "@solana/wallet-adapter-react";
import { FaStar } from "react-icons/fa";
import { fetchUserByAddress } from "../helpers/fetchUserByAddress";

const NetWorth = ({ info }) => {
  const [isClicked, setIsClicked] = useState(false);

  const handleClick = () => {
    setIsClicked(!isClicked);
  };
  const { wallet } = useWallet();
  const passthroughWalletContextState = useWallet();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isSecondOpen,
    onOpen: onSecondOpen,
    onClose: onSecondClose,
  } = useDisclosure();
  const [isChecked, setIsChecked] = useState(false);
  const [datas, setDatas] = useState([]);
  const [datas2, setDatas2] = useState([]);
  const [address, setAddress] = useState(info);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tokenInfo, setTokenInfo] = useState([]);
  const [shitInfo, setShitInfo] = useState([]);

  const [sortOrder, setSortOrder] = useState("desc"); // Initial sorting order: descending
  const [sortedData, setSortedData] = useState(datas?.data?.assets);
  const [loading, setLoading] = useState(false);
  const [netWorth, setNetWorth] = useState(0);
  const [search, setSearch] = useState("");
  const [shitSearch, setShitSearch] = useState("");
  const [txHistory, setTxHistory] = useState([]);

  const options = {
    method: "GET",
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `https://chainpulseserver.onrender.com/api/wallet/balances/${address}`,
          {
            headers: {
              "Content-Type": "application/json",
              "x-api-key": process.env.REACT_APP_API_KEY,
            },
          }
        );

        setDatas(response?.data);
      } catch (err) {
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [address]);

  const inputRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const toast = useToast();
  const handleCopyToClipboard = () => {
    const formattedAddress = datas?.data?.wallet
      ?.toLowerCase()
      ?.startsWith("0x")
      ? datas?.data?.wallet?.toLowerCase()
      : `${datas?.data?.wallet?.toLowerCase()}`;

    // Copy the formatted address to the clipboard
    navigator.clipboard
      .writeText(formattedAddress)
      .then(() => {
        toast({
          description: "Address copied",
          status: "success",
          duration: 9000,
          isClosable: true,
        });
      })
      .catch((error) => {});
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(delay);
  }, []);
  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "f") {
      inputRef.current.focus();
    }
  };

  const contractIndex = tokenInfo?.asset?.contracts.findIndex(
    (contract) => !contract.startsWith("0x")
  );

  const contract =
    contractIndex !== -1 ? tokenInfo?.asset?.contracts[contractIndex] : null;

  const handleSwitchChange = () => {
    setIsChecked((prev) => !prev);
  };

  const url = `https://mainnet.helius-rpc.com/?api-key=${process.env.REACT_APP_HELIUS_KEY}`;

  const getAssetsByOwner = async () => {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        jsonrpc: "2.0",
        id: "my-id",
        method: "getAssetsByOwner",
        params: {
          ownerAddress: address,
          page: 1, // Starts at 1
          limit: 1000,
          displayOptions: {
            showFungible: true, //return both fungible and non-fungible tokens
          },
        },
      }),
    });
    const { result } = await response?.json();
    setDatas2(result?.items);
  };

  useEffect(() => {
    try {
      setTimeout(() => {
        getAssetsByOwner();
      }, 5000);
    } catch (e) {}
  }, [address]);

  function formatBalanceWithSuffix2(balance) {
    if (balance >= 1e6) {
      return (balance / 1e6)?.toFixed(2) + "M";
    } else if (balance >= 1e3) {
      return (balance / 1e3)?.toFixed(2) + "K";
    } else {
      return balance?.toFixed(2);
    }
  }

  const handleSort = () => {
    const newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(newSortOrder);

    const sortedAssets = datas.data.assets.sort((a, b) => {
      if (sortOrder === "asc") {
        return b.unrealized_pnl - a.unrealized_pnl;
      } else {
        return a.unrealized_pnl - b.unrealized_pnl;
      }
    });

    setSortedData(sortedAssets);
  };

  useEffect(() => {
    if (datas2?.length !== 0 && datas?.data?.total_wallet_balance) {
      const sumOfQuotes = datas2?.reduce((total, obj) => {
        if (obj.token_info?.price_info) {
          return total + obj.token_info.price_info?.total_price;
        }
        return total;
      }, 0);
      setNetWorth(Number(sumOfQuotes + datas.data.total_wallet_balance));
    }
  }, [datas, datas2]);

  const fetchDataForTransactions = async () => {
    try {
      const response = await axios.get(
        `https://chainpulseserver.onrender.com/api/getTransactions/${address}`,
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_API_KEY,
          },
        }
      );
      setTxHistory(response?.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    fetchDataForTransactions();
  }, [address]);

  const initJupiter = () => {
    if (wallet) {
      window.Jupiter.init({
        displayMode: "widget",
        endpoint: `https://solana-mainnet.g.alchemy.com/v2/${process.env.REACT_APP_ALCHEMY_API_KEY}`,
        strictTokenList: false,
        passThroughWallet: wallet,
        formProps: {
          fixedOutputMint: false,
          initialOutputMint: "6VXq8brmqKJ2whzpmPypMvrzitgmYYE3bvjrVdXsYLCR",
        },
      });
    }
  };

  initJupiter();

  const [user, setUser] = useState({});

  const fetchStuff = async () => {
    setInterval(async () => {
      const userInfo = await fetchUserByAddress(address);
      setUser(userInfo);
    }, 3000);
  };

  useEffect(() => {
    try {
      fetchStuff();
    } catch (e) {}
  }, [address]);

  const updateUserFavorites = async (favorites) => {
    try {
      await axios.patch(
        `https://chainpulseserver.onrender.com/api/updateUser/${user?._id}`,
        { favorites: favorites }, // Wrap favorites inside an object
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_API_KEY,
          },
        }
      );

      toast({
        description: "Favorites updated successfully",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        description: error?.response?.data?.error,
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  };

  /*   console.log(tokenInfo); */

  return (
    <div>
      {datas?.data === undefined || datas?.data === null ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            backgroundColor: "black",
          }}
        >
          <HStack>
            <Box mr="5px">Reading your wallet's pulse</Box>
            <Box>
              <Spinner size="sm" />
            </Box>
          </HStack>
        </div>
      ) : (
        <Flex
          flexDir="column"
          w="100%"
          alignItems="center"
          justifyContent="center"
          mt="20px"
        >
          <Box
            mb="30px"
            bg="#29292c"
            w={{ base: "350px", md: "400px" }}
            borderRadius="10px"
          >
            <HStack
              w={{ base: "100%", md: "100%" }}
              alignItems="center"
              p="5px"
            >
              <Input
                ref={inputRef}
                color="#636364"
                placeholder="Search any Solana address"
                h="25px"
                border="none"
                fontSize="14px"
                focusBorderColor="#29292c"
                onKeyDown={handleKeyDown}
                onChange={(e) => {
                  setAddress(e?.target?.value);
                }}
              />
              {loading ? (
                <>
                  <Spinner size="sm" />
                </>
              ) : (
                ""
              )}
              {/*   <Kbd>CTRL</Kbd>
              <Box>+</Box>
              <Kbd mr="5px">F</Kbd> */}
            </HStack>
          </Box>
          <Flex
            p="20px"
            w={{ base: "100%", md: "50%" }}
            alignItems="flex-start"
            justifyContent="flex-start"
          >
            <Image
              borderRadius="10px"
              border="5px solid #f5f5f7"
              _dark={{ border: "5px solid #15161a" }}
              src={`https://www.gravatar.com/avatar/${datas?.data?.address}?d=identicon`}
              boxSize={{ base: "70px", md: "100px" }}
            />
            <Flex
              flexDir="column"
              w="100%"
              alignItems="flex-start"
              justifyContent="flex-start"
            >
              <Box
                ml="15px"
                fontSize={{ base: "30px", md: "46px" }}
                fontWeight="700"
                mt="-10px"
              >
                $
                {Number(datas?.data?.total_wallet_balance || netWorth)?.toFixed(
                  3
                )}
              </Box>
              {/*  <Box
                ml="15px"
                fontSize={{ base: "30px", md: "46px" }}
                fontWeight="700"
                mt="-10px"
              >
                ${netWorth?.toFixed(3)}
              </Box> */}

              <HStack mt="-10px">
                <Box color="white" ml="15px" fontWeight="600">
                  {" "}
                  {datas?.data?.wallet?.slice(0, 8) +
                    "...." +
                    datas?.data?.wallet?.slice(-6)}
                </Box>
                <Box
                  onClick={() => handleCopyToClipboard()}
                  color="gray.500"
                  _hover={{ cursor: "pointer" }}
                >
                  <FaRegCopy size="10px" />
                </Box>
              </HStack>
              <HStack alignItems="center">
                <Box
                  color="gray.500"
                  ml="15px"
                  fontWeight="600"
                  mt={{ base: "-5px", md: "0px" }}
                >
                  Unrealized PnL:
                </Box>
                <Box
                  mt="-5px"
                  color={
                    Number(datas?.data?.total_unrealized_pnl) > 0
                      ? "#0db68c"
                      : "#cd4976"
                  }
                  mr="-5px"
                >
                  {Number(datas?.data?.total_unrealized_pnl) > 0 ? (
                    <Box mb="-10px">
                      <FaSortUp />
                    </Box>
                  ) : (
                    <FaSortDown />
                  )}
                </Box>
                <Box
                  color={
                    Number(datas?.data?.total_unrealized_pnl) > 0
                      ? "#0db68c"
                      : "#cd4976"
                  }
                >
                  ${Number(datas?.data?.total_unrealized_pnl)?.toFixed(3)}
                </Box>
              </HStack>
            </Flex>
          </Flex>

          <Flex
            p="20px"
            w={{ base: "100%", md: "50%" }}
            alignItems="flex-start"
            justifyContent="flex-start"
          >
            <Tabs colorScheme="green" w="100%" mt="20px">
              <TabList>
                <Tab>Tokens</Tab>
                <Tab>NFTs</Tab>
                <Tab>Transactions</Tab>
              </TabList>

              {/*   <Chart address={address} /> */}

              <TabPanels>
                <TabPanel
                  w={{ base: "108%", md: "105%" }}
                  ml={{ base: "-16px", md: "-16px" }}
                >
                  {" "}
                  <Chart
                    address={address}
                    txHistory={txHistory}
                    tokens={datas?.data?.assets}
                  />
                  <Box mb="10px" mt="10px">
                    <HStack>
                      <Box>Show shitcoins in total</Box>
                      <Box>
                        <Switch
                          size="sm"
                          isChecked={isChecked}
                          onChange={handleSwitchChange}
                        />
                      </Box>
                    </HStack>
                  </Box>
                  <Box
                    w="100%"
                    h={{ base: "600px", md: "400px" }}
                    border="1px solid #292929"
                    borderRadius="10px"
                    p="15px"
                    overflow="auto"
                  >
                    {/* umtiti */}
                    {isChecked === false ? (
                      <>
                        <Flex
                          w="100%"
                          alignItems="center"
                          justifyContent="space-between"
                          flexDir={{ base: "column", md: "row" }}
                        >
                          <Input
                            bg="#29292c"
                            ref={inputRef}
                            color="#636364"
                            placeholder="Search for your assets"
                            border="none"
                            fontSize="14px"
                            h="35px"
                            focusBorderColor="#29292c"
                            w={{ base: "100%", md: "50%" }}
                            onChange={(e) => {
                              setSearch(e?.target?.value);
                            }}
                            mb="10px"
                          />
                          <PieCharts info={datas?.data?.assets} />
                        </Flex>

                        <TableContainer>
                          <Table variant="simple">
                            <Thead fontSize="11px">
                              <Tr>
                                <Th>ASSET</Th>
                                <Th>PRICE</Th>
                                <Th>BALANCE</Th>
                                <Th>
                                  VALUE & UPNL{" "}
                                  <Box
                                    display="inline-block"
                                    cursor="pointer"
                                    onClick={handleSort}
                                  >
                                    {sortOrder === "asc" ? (
                                      <FaChevronUp
                                        fontSize="10px"
                                        color="gray.500"
                                        alignSelf="center"
                                      />
                                    ) : (
                                      <FaChevronDown
                                        fontSize="10px"
                                        color="gray.500"
                                        alignSelf="center"
                                      />
                                    )}
                                  </Box>
                                </Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {datas?.data?.assets
                                .filter(
                                  (e) =>
                                    e.asset.name
                                      .toLowerCase()
                                      .includes(search.toLowerCase()) ||
                                    e.asset.symbol
                                      .toLowerCase()
                                      .includes(search.toLowerCase())
                                )
                                ?.map((e, i) => {
                                  return (
                                    <>
                                      <Tr
                                        _hover={{
                                          bg: "gray.800",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          setTokenInfo(e);

                                          onOpen();
                                        }}
                                      >
                                        <Td>
                                          <HStack>
                                            <Image
                                              src={e?.asset?.logo}
                                              boxSize="35px"
                                              borderRadius="300px"
                                              bg="white"
                                              fallbackSrc="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSP0eSnQyTzpoQwl2gYy6F-G-Nhu6MXxOps8R6IGbKcmQ&s"
                                            />

                                            <Flex
                                              flexDir="column"
                                              fontSize="14px"
                                              alignItems="flex-start"
                                            >
                                              <Box color="white">
                                                {e?.asset?.name}
                                              </Box>
                                              <Box color="gray.500">
                                                {" "}
                                                {e?.asset?.symbol}
                                              </Box>
                                            </Flex>
                                          </HStack>
                                        </Td>
                                        <Td fontSize="14px">
                                          ${Number(e?.price)?.toFixed(3)}
                                        </Td>
                                        <Td fontSize="14px">
                                          {e?.token_balance} {e?.asset?.symbol}
                                        </Td>
                                        <Td fontSize="14px">
                                          <Flex
                                            flexDir="column"
                                            fontSize="14px"
                                            alignItems="flex-start"
                                          >
                                            <Box color="white">
                                              {" "}
                                              $
                                              {Number(
                                                e?.token_balance * e?.price
                                              )?.toFixed(3)}
                                            </Box>
                                            <HStack alignItems="center">
                                              <Box
                                                mt="-5px"
                                                color={
                                                  Number(e?.unrealized_pnl) > 0
                                                    ? "#0db68c"
                                                    : "#cd4976"
                                                }
                                                mr="-5px"
                                              >
                                                {Number(e?.unrealized_pnl) >
                                                0 ? (
                                                  <Box mb="-10px">
                                                    <FaSortUp />
                                                  </Box>
                                                ) : (
                                                  <FaSortDown />
                                                )}
                                              </Box>

                                              <Box
                                                color={
                                                  Number(e?.unrealized_pnl) > 0
                                                    ? "#0db68c"
                                                    : "#cd4976"
                                                }
                                              >
                                                $
                                                {Number(
                                                  e?.unrealized_pnl
                                                )?.toFixed(3)}
                                              </Box>
                                            </HStack>
                                            <Box color="gray.500"></Box>
                                          </Flex>
                                        </Td>
                                      </Tr>
                                    </>
                                  );
                                })}
                            </Tbody>
                          </Table>
                        </TableContainer>
                      </>
                    ) : (
                      <>
                        <Input
                          bg="#29292c"
                          ref={inputRef}
                          color="#636364"
                          placeholder="Search for your assets"
                          border="none"
                          fontSize="14px"
                          h="35px"
                          focusBorderColor="#29292c"
                          w={{ base: "100%", md: "50%" }}
                          onChange={(e) => {
                            setShitSearch(e?.target?.value);
                          }}
                          mb="10px"
                        />

                        <TableContainer>
                          <Table variant="simple">
                            <Thead fontSize="11px">
                              <Tr>
                                <Th>ASSET</Th>
                                <Th>PRICE</Th>
                                <Th>BALANCE</Th>
                                <Th>VALUE </Th>
                              </Tr>
                              {/* here */}
                            </Thead>
                            <Tbody>
                              {datas2?.data?.assets
                                .filter(
                                  (e) =>
                                    e.asset.name
                                      .toLowerCase()
                                      .includes(shitSearch.toLowerCase()) ||
                                    e.asset.symbol
                                      .toLowerCase()
                                      .includes(shitSearch.toLowerCase())
                                )
                                ?.map((e, i) => {
                                  if (String(e?.interface) === "V1_NFT") {
                                    // If interface is "V1_NFT", don't render the row
                                    return null;
                                  } else if (
                                    String(e?.interface) === "FungibleAsset" ||
                                    String(e?.interface) === "FungibleToken"
                                  ) {
                                    return (
                                      <>
                                        <Tr
                                          _hover={{
                                            bg: "gray.800",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            setShitInfo(e);

                                            onSecondOpen();
                                          }}
                                        >
                                          <Td>
                                            <HStack>
                                              <Image
                                                src={e?.content?.links?.image}
                                                boxSize="35px"
                                                borderRadius="300px"
                                                bg="white"
                                                fallbackSrc="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSP0eSnQyTzpoQwl2gYy6F-G-Nhu6MXxOps8R6IGbKcmQ&s"
                                              />

                                              <Flex
                                                flexDir="column"
                                                fontSize="14px"
                                                alignItems="flex-start"
                                              >
                                                <Box color="white">
                                                  {e?.content?.metadata?.name}
                                                </Box>
                                                <Box color="gray.500">
                                                  {" "}
                                                  {e?.content?.metadata?.symbol}
                                                </Box>
                                              </Flex>
                                            </HStack>
                                          </Td>
                                          <Td fontSize="14px">
                                            ${" "}
                                            {isNaN(
                                              e?.token_info?.price_info
                                                ?.price_per_token
                                            )
                                              ? "0.000" // If NaN, display "0.000"
                                              : Number(
                                                  e?.token_info?.price_info
                                                    ?.price_per_token
                                                ).toFixed(3)}
                                          </Td>
                                          <Td fontSize="14px">
                                            {formatBalanceWithSuffix2(
                                              e?.token_info?.balance /
                                                10 ** e?.token_info?.decimals
                                            )}{" "}
                                            {e?.token_info?.symbol}
                                          </Td>
                                          <Td fontSize="14px">
                                            <Flex
                                              flexDir="column"
                                              fontSize="14px"
                                              alignItems="flex-start"
                                            >
                                              <Box color="white">
                                                {" "}
                                                $
                                                {isNaN(
                                                  e?.token_info?.price_info
                                                    ?.total_price
                                                )
                                                  ? "0.000" // If NaN, display "0.000"
                                                  : Number(
                                                      e?.token_info?.price_info
                                                        ?.total_price
                                                    ).toFixed(3)}
                                              </Box>
                                            </Flex>
                                          </Td>
                                        </Tr>
                                      </>
                                    );
                                  }
                                })}
                            </Tbody>
                          </Table>
                        </TableContainer>
                      </>
                    )}
                  </Box>
                </TabPanel>
                <TabPanel
                  w={{ base: "108%", md: "105%" }}
                  ml={{ base: "-16px", md: "-16px" }}
                >
                  <NFTView datas2={datas2} />
                </TabPanel>
                <TabPanel>
                  <Transactions info={address} txHistory={txHistory} />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Flex>
        </Flex>
      )}

      <Modal
        size={{ base: "full", md: "md" }}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent borderRadius="20px" bg={{ base: "black", md: "#15161a" }}>
          <ModalHeader>
            Your{" "}
            <Box
              as="span"
              bgGradient="linear(to-r, #53e0ac, #b958ee)"
              bgClip="text"
            >
              {" "}
              {tokenInfo?.asset?.name}
            </Box>{" "}
            holdings info
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <HStack>
              <Box>
                <Image
                  src={tokenInfo?.asset?.logo}
                  boxSize="50px"
                  borderRadius="300px"
                  fallbackSrc="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSP0eSnQyTzpoQwl2gYy6F-G-Nhu6MXxOps8R6IGbKcmQ&s"
                />
              </Box>
              <Flex
                flexDir="column"
                alignItems="flex-start"
                justifyContent="center"
              >
                <Box color="gray.500" fontSize="12px">
                  {tokenInfo?.asset?.name}
                </Box>
                <Box fontSize="16px">${tokenInfo?.asset?.symbol}</Box>
              </Flex>

              <Box>
                <div
                  style={{
                    display: "inline-block",
                    cursor: "pointer",
                    transition: "background-color 0.3s ease",
                    /*  color: isClicked ? "gold" : "white", */
                    borderRadius: isClicked ? "50%" : "0",
                    animation: isClicked ? "pulse 0.5s ease" : "none",
                  }}
                  onClick={() => {
                    handleClick();
                    updateUserFavorites([tokenInfo?.asset]);
                  }}
                >
                  <FaStar color={isClicked ? "gold" : "white"} />
                </div>
              </Box>
            </HStack>
            <Box
              mt="20px"
              borderRadius="10px"
              border="1px dashed gray"
              p="10px"
            >
              <Flex
                alignItems="center"
                justifyContent="center"
                flexDir="column"
              >
                <Box fontSize="80px" fontWeight="600">
                  $
                  {Number(tokenInfo?.token_balance * tokenInfo?.price)?.toFixed(
                    3
                  )}
                </Box>
                <Box>
                  <HStack alignItems="center">
                    <Box>
                      <Image
                        src={tokenInfo?.asset?.logo}
                        boxSize="15px"
                        borderRadius="300px"
                      />
                    </Box>

                    <Box color="gray.500" fontSize="14px">
                      {tokenInfo?.token_balance}
                    </Box>
                    <Box color="gray.500" fontSize="14px">
                      {" "}
                      {tokenInfo?.asset?.symbol}
                    </Box>
                  </HStack>
                </Box>
              </Flex>
            </Box>

            <Flex
              mt="20px"
              w="100%"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box color="gray.500">Your total investment</Box>
              <Box fontWeight="600">
                ${Number(tokenInfo?.total_invested)?.toFixed(3)}
              </Box>
            </Flex>
            <Flex
              mt="10px"
              w="100%"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box color="gray.500">Price bought at</Box>
              <Box fontWeight="600">
                ${Number(tokenInfo?.price_bought)?.toFixed(3)}
              </Box>
            </Flex>
            <Flex
              mt="10px"
              w="100%"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box color="gray.500">Unrealized PnL</Box>
              <Box fontWeight="600">
                ${Number(tokenInfo?.unrealized_pnl)?.toFixed(3)}
              </Box>
            </Flex>
            <Flex
              mt="10px"
              w="100%"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box color="gray.500">Realized PnL</Box>
              <Box fontWeight="600">
                ${Number(tokenInfo?.realized_pnl)?.toFixed(3)}
              </Box>
            </Flex>

            <Flex
              mt="10px"
              w="100%"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box color="gray.500">Contract</Box>
              <Link href={`https://solscan.io/token/${contract}`} isExternal>
                <Box fontWeight="600">{contract?.slice(0, 12)}...</Box>
              </Link>
            </Flex>
          </ModalBody>

          <Box
            id="dexscreener-embed"
            position="relative"
            width="100%"
            paddingBottom="125%"
            overflow="hidden"
            backgroundColor="black"
            mt="20px"
          >
            <iframe
              src={`https://dexscreener.com/solana/${contract}?embed=1&theme=dark`}
              frameBorder="0"
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                top: "0",
                left: "0",
              }}
            ></iframe>
          </Box>

          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        size={{ base: "full", md: "md" }}
        isOpen={isSecondOpen}
        onClose={onSecondClose}
      >
        <ModalOverlay />
        <ModalContent borderRadius="20px" bg={{ base: "black", md: "#15161a" }}>
          <ModalHeader>
            Your{" "}
            <Box
              as="span"
              bgGradient="linear(to-r, #53e0ac, #b958ee)"
              bgClip="text"
            >
              {" "}
              {shitInfo?.token_info?.symbol}
            </Box>{" "}
            holdings info
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <HStack>
              <Box>
                <Image
                  src={shitInfo?.content?.links?.image}
                  boxSize="50px"
                  borderRadius="300px"
                  fallbackSrc="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSP0eSnQyTzpoQwl2gYy6F-G-Nhu6MXxOps8R6IGbKcmQ&s"
                />
              </Box>
              <Flex
                flexDir="column"
                alignItems="flex-start"
                justifyContent="center"
              >
                <Box color="gray.500" fontSize="12px">
                  {shitInfo?.content?.metadata?.name}
                </Box>
                <Box fontSize="16px">${shitInfo?.token_info?.symbol}</Box>
              </Flex>
            </HStack>
            <Box
              mt="20px"
              borderRadius="10px"
              border="1px dashed gray"
              p="10px"
            >
              <Flex
                alignItems="center"
                justifyContent="center"
                flexDir="column"
              >
                <Box fontSize="80px" fontWeight="600">
                  $
                  {Number(
                    shitInfo?.token_info?.price_info?.total_price
                  )?.toFixed(3)}
                </Box>
                <Box>
                  <HStack alignItems="center">
                    <Box>
                      <Image
                        src={shitInfo?.content?.links?.image}
                        boxSize="15px"
                        borderRadius="300px"
                      />
                    </Box>

                    <Box color="gray.500" fontSize="14px">
                      {formatBalanceWithSuffix2(shitInfo?.token_info?.balance)}
                    </Box>
                    <Box color="gray.500" fontSize="14px">
                      {" "}
                      {shitInfo?.token_info?.symbol}
                    </Box>
                  </HStack>
                </Box>
              </Flex>
            </Box>

            <Flex
              mt="10px"
              w="100%"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box color="gray.500">Contract</Box>
              <Link
                href={`https://solscan.io/token/${shitInfo?.id}`}
                isExternal
              >
                <Box fontWeight="600">
                  {shitInfo?.id?.slice(0, 12)}
                  ...
                </Box>
              </Link>
            </Flex>

            <Box mt="20px" fontSize="14px" color="gray.500">
              {shitInfo?.content?.metadata?.description}
            </Box>
          </ModalBody>

          <Box
            id="dexscreener-embed"
            position="relative"
            width="100%"
            paddingBottom="125%"
            overflow="hidden"
            backgroundColor="black"
            mt="20px"
          >
            <iframe
              src={`https://dexscreener.com/solana/${shitInfo?.id}?embed=1&theme=dark`}
              frameBorder="0"
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                top: "0",
                left: "0",
              }}
            ></iframe>
          </Box>

          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default NetWorth;
